import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-3dc50d0f"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "LeaveReview"
};
var _hoisted_2 = {
  "class": "modal"
};
var _hoisted_3 = {
  "class": "modal-content"
};
var _hoisted_4 = {
  key: 1,
  "class": "encouragement"
};
var _hoisted_5 = {
  key: 2,
  "class": "encouragement"
};
var _hoisted_6 = {
  key: 3,
  "class": "modal-summary"
};
var _hoisted_7 = {
  key: 4,
  "class": "modal-summary modal-summary--blue"
};
var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("u", null, "Read the Story", -1);
});
var _hoisted_9 = {
  key: 5,
  src: "assets/web/allavatars.webp",
  alt: "Feedback",
  "class": "modal-image"
};
var _hoisted_10 = {
  key: 6
};
var _hoisted_11 = {
  "class": "stars"
};
var _hoisted_12 = {
  key: 0,
  "class": "encouragement"
};
var _hoisted_13 = {
  key: 0,
  "class": "feedbackInput__holder"
};
var _hoisted_14 = {
  "class": "modal-summary"
};
var _hoisted_15 = {
  "class": "review-button__holder"
};
var _hoisted_16 = {
  key: 1,
  "class": "results"
};
var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", null, "so happy", -1);
});
var _hoisted_18 = {
  key: 2,
  "class": "results"
};
var _hoisted_19 = {
  key: 3,
  "class": "results"
};
var _hoisted_20 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", null, "really appreciate", -1);
});
var _hoisted_21 = {
  key: 4,
  "class": "results"
};
var _hoisted_22 = {
  href: "https://play.google.com/store/apps/details?id=com.aivitar.aivitarapp&showAllReviews=true"
};
var _hoisted_23 = {
  key: 0,
  "class": "review-button"
};
var _hoisted_24 = {
  key: 7
};
var _hoisted_25 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    "class": "encouragement"
  }, "Thank you for your feedback!", -1);
});
var _hoisted_26 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    "class": "encouragement"
  }, "You can also talk with me directly by joining the discord group!", -1);
});
var _hoisted_27 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("a", {
    href: "https://discord.gg/aQJXgbXaZp",
    target: "_blank"
  }, [/*#__PURE__*/_createElementVNode("button", {
    "class": "discord-button"
  }, [/*#__PURE__*/_createElementVNode("div", {
    "class": "discord"
  }, [/*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "45",
    height: "46",
    viewBox: "0 0 45 46",
    fill: "none"
  }, [/*#__PURE__*/_createElementVNode("g", {
    filter: "url(#filter0_d)"
  }, [/*#__PURE__*/_createElementVNode("path", {
    d: "M29.8594 0H9.14062C4.0924 0 0 4.0924 0 9.14062V29.8594C0 34.9076 4.0924 39 9.14062 39H29.8594C34.9076 39 39 34.9076 39 29.8594V9.14062C39 4.0924 34.9076 0 29.8594 0Z",
    fill: "#2F2F2F"
  })]), /*#__PURE__*/_createElementVNode("mask", {
    id: "mask0",
    style: {
      "mask-type": "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: "4",
    y: "7",
    width: "31",
    height: "25"
  }, [/*#__PURE__*/_createElementVNode("path", {
    d: "M4.26562 7.76953H34.7344V31.3721H4.26562V7.76953Z",
    fill: "white"
  })]), /*#__PURE__*/_createElementVNode("g", {
    mask: "url(#mask0)"
  }, [/*#__PURE__*/_createElementVNode("path", {
    d: "M30.0587 9.87141C28.0833 8.96464 25.9987 8.31802 23.8569 7.94777C23.8374 7.94417 23.8173 7.94679 23.7995 7.95527C23.7816 7.96375 23.7668 7.97765 23.7573 7.995C23.4895 8.47122 23.1927 9.09278 22.985 9.5812C20.6431 9.2305 18.3133 9.2305 16.0194 9.5812C15.8116 9.08182 15.5042 8.47122 15.2352 7.995C15.2252 7.97801 15.2104 7.96441 15.1926 7.95599C15.1748 7.94756 15.1548 7.9447 15.1354 7.94777C12.9934 8.31727 10.9087 8.96392 8.93362 9.87141C8.91671 9.87859 8.90245 9.89083 8.89279 9.90645C4.94282 15.8076 3.86088 21.5638 4.39164 27.2487C4.39312 27.2626 4.39739 27.2761 4.40419 27.2883C4.411 27.3006 4.4202 27.3113 4.43125 27.32C7.03724 29.2338 9.56173 30.3958 12.0393 31.1659C12.0586 31.1716 12.0791 31.1713 12.0983 31.1651C12.1174 31.1588 12.1341 31.1469 12.1462 31.1308C12.7323 30.3304 13.2547 29.4866 13.7027 28.5992C13.7089 28.587 13.7124 28.5737 13.7131 28.5601C13.7137 28.5465 13.7115 28.5329 13.7065 28.5202C13.7015 28.5075 13.6939 28.496 13.6841 28.4865C13.6743 28.477 13.6627 28.4697 13.6499 28.465C12.8211 28.1505 12.0321 27.7674 11.2732 27.3321C11.2593 27.324 11.2477 27.3126 11.2394 27.2989C11.231 27.2852 11.2261 27.2697 11.2252 27.2537C11.2242 27.2376 11.2272 27.2216 11.2339 27.2071C11.2406 27.1925 11.2508 27.1798 11.2636 27.17C11.4237 27.0504 11.581 26.927 11.7355 26.8002C11.749 26.789 11.7654 26.7818 11.7828 26.7794C11.8002 26.7771 11.8179 26.7796 11.8339 26.7867C16.8205 29.0634 22.2188 29.0634 27.1463 26.7867C27.1624 26.7791 27.1803 26.7762 27.198 26.7784C27.2156 26.7805 27.2323 26.7877 27.2461 26.7989C27.4007 26.9265 27.5585 27.0503 27.7193 27.17C27.7321 27.1797 27.7424 27.1923 27.7492 27.2068C27.756 27.2213 27.7591 27.2373 27.7583 27.2533C27.7574 27.2693 27.7527 27.2849 27.7444 27.2986C27.7362 27.3124 27.7246 27.3239 27.7109 27.3321C26.9515 27.7755 26.156 28.1541 25.333 28.4638C25.3202 28.4686 25.3086 28.4762 25.2989 28.4858C25.2892 28.4955 25.2817 28.5071 25.2768 28.5199C25.272 28.5327 25.2698 28.5464 25.2706 28.56C25.2714 28.5737 25.275 28.587 25.2813 28.5992C25.7371 29.4795 26.2569 30.3253 26.8364 31.1296C26.8482 31.1461 26.8649 31.1584 26.8841 31.1649C26.9033 31.1714 26.924 31.1718 26.9434 31.1659C29.433 30.3958 31.9575 29.2338 34.5636 27.32C34.5748 27.3117 34.5841 27.3012 34.5909 27.2891C34.5978 27.2771 34.6019 27.2637 34.6032 27.2499C35.2385 20.6776 33.5391 14.9685 30.0983 9.90767C30.0898 9.89123 30.0758 9.87836 30.0587 9.87141ZM14.4474 23.7873C12.946 23.7873 11.709 22.409 11.709 20.7163C11.709 19.0236 12.9221 17.6454 14.4474 17.6454C15.9845 17.6454 17.2095 19.0358 17.1855 20.7163C17.1855 22.409 15.9725 23.7873 14.4474 23.7873ZM24.5716 23.7873C23.0702 23.7873 21.8333 22.409 21.8333 20.7163C21.8333 19.0236 23.0463 17.6454 24.5716 17.6454C26.1087 17.6454 27.3337 19.0358 27.3098 20.7163C27.3098 22.409 26.1087 23.7873 24.5716 23.7873Z",
    fill: "white"
  })]), /*#__PURE__*/_createElementVNode("defs", null, [/*#__PURE__*/_createElementVNode("filter", {
    id: "filter0_d",
    x: "0",
    y: "0",
    width: "45",
    height: "46",
    filterUnits: "userSpaceOnUse",
    "color-interpolation-filters": "sRGB"
  }, [/*#__PURE__*/_createElementVNode("feFlood", {
    "flood-opacity": "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/_createElementVNode("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/_createElementVNode("feOffset", {
    dx: "3",
    dy: "4"
  }), /*#__PURE__*/_createElementVNode("feGaussianBlur", {
    stdDeviation: "1.5"
  }), /*#__PURE__*/_createElementVNode("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/_createElementVNode("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/_createElementVNode("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_50_475"
  }), /*#__PURE__*/_createElementVNode("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_50_475",
    result: "shape"
  })])])])]), /*#__PURE__*/_createTextVNode(" Join me on discord ")])], -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_Transition, {
    name: "fade"
  }, {
    "default": _withCtx(function () {
      return [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [!_ctx.success ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
        key: 0,
        icon: "times",
        "class": "close-icon",
        onClick: _ctx.handleClose
      }, null, 8, ["onClick"])) : _createCommentVNode("", true), _ctx.showReviewButton ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Your Rating")) : _createCommentVNode("", true), !_ctx.showReviewButton && !_ctx.success ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Enjoying the app? Let us know!")) : _createCommentVNode("", true), !_ctx.showReviewButton && !_ctx.handleLowerScores && !_ctx.success ? (_openBlock(), _createElementBlock("p", _hoisted_6, " Your opinion matters to us. Let us know how you're liking the app so far! ")) : _createCommentVNode("", true), !_ctx.handleLowerScores && !_ctx.success ? (_openBlock(), _createElementBlock("p", _hoisted_7, [_createTextVNode(" Did you know this app was made by one person over the last 16 months? "), _hoisted_8])) : _createCommentVNode("", true), !_ctx.showReviewButton ? (_openBlock(), _createElementBlock("img", _hoisted_9)) : _createCommentVNode("", true), !_ctx.success ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, function (n) {
        return _createVNode(_component_font_awesome_icon, {
          key: n,
          "class": _normalizeClass({
            stars: true,
            active: _ctx.rating >= n
          }),
          icon: "star",
          onClick: function onClick($event) {
            return _ctx.changeStars(n);
          }
        }, null, 8, ["class", "onClick"]);
      }), 64))]), !_ctx.showReviewButton && !_ctx.handleLowerScores ? (_openBlock(), _createElementBlock("p", _hoisted_12, "Tell us, how are you enjoying the app?")) : _createCommentVNode("", true), _createElementVNode("div", null, [_ctx.handleLowerScores ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.lowerScoreSentence), 1), _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _ctx.feedback = $event;
        }),
        placeholder: "Click to provide your comments",
        "class": _normalizeClass({
          feedbackInput: true
        })
      }, null, 512), [[_vModelText, _ctx.feedback]]), _createElementVNode("button", {
        "class": "review-button",
        onClick: _cache[1] || (_cache[1] = function () {
          return _ctx.submitFeedback && _ctx.submitFeedback.apply(_ctx, arguments);
        })
      }, _toDisplayString(_ctx.shareFeedbackText), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_15, [!_ctx.hasSubmittedRating ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        "class": "review-button",
        onClick: _cache[2] || (_cache[2] = function () {
          return _ctx.submitRating && _ctx.submitRating.apply(_ctx, arguments);
        })
      }, " Submit ")) : _createCommentVNode("", true), _ctx.showReviewButton ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createTextVNode("We're "), _hoisted_17, _createTextVNode(" that you're enjoying the app!")])) : _createCommentVNode("", true), _ctx.showReviewButton ? (_openBlock(), _createElementBlock("div", _hoisted_18, "Currently, we're struggling with positive reviews for this app since mostly only unhappy people tend to spend the time to review.")) : _createCommentVNode("", true), _ctx.showReviewButton ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createTextVNode(" I would "), _hoisted_20, _createTextVNode(" if you would take the time to help leave a positive review to help support this app.")])) : _createCommentVNode("", true), _ctx.showReviewButton ? (_openBlock(), _createElementBlock("div", _hoisted_21, "Can I count on you to help ? ")) : _createCommentVNode("", true), _createElementVNode("a", _hoisted_22, [_ctx.showReviewButton ? (_openBlock(), _createElementBlock("button", _hoisted_23, " Click To Leave Review ")) : _createCommentVNode("", true)])])])])) : _createCommentVNode("", true), _ctx.success ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_hoisted_25, _hoisted_26, _hoisted_27, _createElementVNode("button", {
        "class": "review-button",
        style: {
          "margin-top": "20px"
        },
        onClick: _cache[3] || (_cache[3] = function () {
          return _ctx.handleClose && _ctx.handleClose.apply(_ctx, arguments);
        })
      }, " Close window ")])) : _createCommentVNode("", true)])])];
    }),
    _: 1
  })]);
}